module.exports = __webpack_public_path__ + "img/A5-4-plan.67b47d3d.png";